module.exports = __webpack_public_path__ + "static/media/audi-intro.ef7be23e.jpg";